import { useEffect } from 'react';
import { Undo2 } from 'lucide-react';

/**
 * Undo toast for a delete (design: Component · Toast — an action, never a confirm dialog
 * before the fact). Sits clear of the bottom tab bar, the iOS home indicator and the
 * floating add button above it.
 */
export function UndoToast({
  message,
  onUndo,
  onDismiss,
  timeoutMs = 7000,
}: {
  message: string;
  onUndo: () => void;
  onDismiss: () => void;
  timeoutMs?: number;
}): JSX.Element {
  useEffect(() => {
    const timer = setTimeout(onDismiss, timeoutMs);
    return () => clearTimeout(timer);
  }, [onDismiss, timeoutMs]);

  return (
    <div
      role="status"
      data-testid="undo-toast"
      className="fixed inset-x-4 bottom-[calc(136px+env(safe-area-inset-bottom))] z-30 flex items-center gap-3 rounded-md bg-inverse px-4 py-3 text-inverse-fg shadow-xl lg:bottom-8 lg:left-auto lg:right-8 lg:w-96"
    >
      <span className="min-w-0 flex-1 truncate text-sm">{message}</span>
      <button
        type="button"
        data-testid="undo-button"
        onClick={onUndo}
        className="flex h-11 shrink-0 items-center gap-1.5 text-sm font-semibold text-accent"
      >
        <Undo2 className="h-4 w-4" /> Undo
      </button>
    </div>
  );
}
